(function () {
	'use strict';

	angular
		.module('mx.components')
		/**
		 * @ngdoc directive
		 * @name mx.components:mxIconPicker
		 * @module mx.components
		 * @restrict 'E'
		 * @description
		 * The mx-icon-picker control is used to create a picker where the user can select icons.
		 *
		 * The example below demonstrates some of the attributes you may use with the Picker control:
		 * @param {string} name@ - The name property sets or returns the value of the name attribute of a mxIconPicker.
		 * @param {string} label@ - Defines control label displayed on the form.
		 * @param {boolean} ng-required= - The required property sets or returns whether a mxPicker must be filled out before submitting a form.
		 * @param {boolean} disabled= - The disabled property sets or returns whether a mxPicker should be disabled, or not.
		 * @param {boolean} readOnly= - The readOnly property sets or returns whether the contents of a mxPicker should be read-only.
		 * @param {object} model=ngModel - directive binds element to the object in the model.
		 * @param {expression} onChange& - on change callback
		 * @usage <mx-icon-picker ng-model="vm.pickerValue" ng-required="true" data-label="Classic, predfined items" > </mx-icon-picker>
		 */
		.directive('mxIconPicker', function mxIconPickerDirective() {
			return new mx.components.FormControlBase(MxIconPickerCtrl, 'mx-icon-picker/mx-icon-picker.html');
		});

	MxIconPickerCtrl.$inject = ['$timeout', '$q', '$scope', '$element', '$mdPanel'];

	function MxIconPickerCtrl($timeout, $q, $scope, $element, $mdPanel) {
		var vm = this,
			dropdownConfig;

		vm.$onInit = function () {
			mx.components.FormControlControllerBase.call(vm, $timeout);
			vm.activate = activate;
			vm.clear = clear;
		};

		vm.$postLink = function () {
			const inputContainerEl = $element.find('> md-input-container');
			const inputEl = $element.find('input');
			vm.setHintHandlers(inputEl);
			inputEl
				.on('focus', () => {
					inputContainerEl.addClass('md-input-focused');
				})
				.on('blur', () => {
					inputContainerEl.removeClass('md-input-focused');
				});
		};

		$scope.$watch('vm.model', function (model) {
			vm.text = model;
			initIcon(model);
		});

		return vm;

		function initIcon(iconId) {
			if (iconId) {
				return mx.components.Icons.some(function (cat) {
					return cat.icons.some(function (icon) {
						if (icon.id === iconId) {
							vm.icon = icon.id;
							return true;
						}
					});
				});
			} else {
				vm.icon = '';
				return false;
			}
		}

		function activate() {
			if (vm._readOnly || vm._disabled) {
				return;
			}
			if (!vm.isDropdownOpen) {
				vm.isDropdownOpen = true;
				setTimeout(function () {
					openIconLib();
				}, 100);
			}
		}

		function openIconLib() {
			dropdownConfig = dropdownConfig || {
				id: 'mx-icon-picker--dropdown-' + Date.now(),
				attachTo: angular.element(document.body),
				controller: 'mx.shell.IconPickerDropdownController',
				controllerAs: 'vm',
				templateUrl: 'mx-icon-picker/mx-icon-picker-dropdown.html',
				escapeToClose: true,
				propagateContainerEvents: true,
				locals: {
					__parentVm: vm,
					__input: $element.find('input'),
					__parentEl: $element,
				},
				onCloseSuccess: function () {
					vm.isDropdownOpen = false;
				},
			};

			dropdownConfig.position = $mdPanel
				.newPanelPosition()
				.relativeTo(dropdownConfig.locals.__input)
				.addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

			dropdownConfig.locals.dropdownWidth = $element.width() - 20;

			$mdPanel.open(dropdownConfig);
		}

		function clear() {
			vm.text = '';
			vm.icon = '';
			vm.model = '';
		}
	}
})();
